__webpack_require__.p = "/reports-migrate-to-standalone/referrals-hub/";